import JSZip from 'jszip'

export const onDownloadMultipleFilesToZip = async ({ urls, downLoadFileName= 'download.zip' }) => {
  const zip = new JSZip()
  await Promise.all(
    urls.map(async (url) => {
      try {
        const response = await fetch(url)
        if (!response.ok) {
          throw new Error(`Error downloading ${url}: ${response.statusText}`)
        }
        const archivoData = await response.blob()
        const filename = url.substring(url.lastIndexOf('/') + 1)
        zip.file(filename, archivoData)
      } catch (error) {
        console.error(error.message)
      }
    })
  )
  const zipContent = await zip.generateAsync({ type: 'blob' })
  const downloadLink = document.createElement('a')
  downloadLink.href = URL.createObjectURL(zipContent)
  downloadLink.download = downLoadFileName
  downloadLink.click()
}

export default onDownloadMultipleFilesToZip